import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { Usuario } from '../models/usuario-sesion.interface';
import { TipoProducto } from '../models/tipo-producto.interface';

@Injectable({ providedIn: 'root' })
export class CatalogoService {


    constructor(private http: HttpClient) { }

    empresas(): Observable<HttpRespuesta<Usuario[]>> {
        return this.http.get<HttpRespuesta<Usuario[]>>(environment.api.empresas);
    }

    tipos_productos(): Observable<HttpRespuesta<TipoProducto[]>> {
        return this.http.get<HttpRespuesta<TipoProducto[]>>(environment.api.tipos_productos);
    }
}